class FreeBundleComponent extends HTMLElement {
  constructor() {
    super();

    this.state = {
      selectedBottles: [],
      maxBottles: 4,
      bundleId: this.generateBundleId(),
      currentTab: 1,
    };
  }

  connectedCallback() {
    this.init();
    this.checkForCheckoutRecovery();
  }

  init() {
    // Get settings from data attributes
    this.standardPrice = parseInt(this.dataset.standardPrice);
    this.standardBundlePrice = parseInt(this.dataset.standardBundlePrice);
    this.maxPrice = parseInt(this.dataset.maxPrice);
    this.maxBundlePrice = parseInt(this.dataset.maxBundlePrice);

    // Store discount codes (bundle + $20 + free shipping)
    this.discountCodes = {
      '4std': this.dataset.discount4std || 'BFCM4STD',
      '3s1m': this.dataset.discount3s1m || 'BFCM3S1M',
      '2s2m': this.dataset.discount2s2m || 'BFCM2S2M',
      '1s3m': this.dataset.discount1s3m || 'BFCM1S3M',
      '4max': this.dataset.discount4max || 'BFCM4MAX',
    };

    // Get free product settings
    this.freeProducts = [];
    for (let i = 1; i <= 3; i++) {
      const variantId = this.dataset[`freeProduct${i}Id`];
      const quantity = parseInt(this.dataset[`freeProduct${i}Qty`]) || 0;
      const title = this.dataset[`freeProduct${i}Title`] || '';

      if (variantId && quantity > 0) {
        this.freeProducts.push({ variantId, quantity, title });
      }
    }

    console.log('[Free Bundle] Free products configured:', this.freeProducts);

    // Setup tab navigation
    this.setupTabs();

    // Setup product buttons
    this.setupProductButtons();

    // Setup checkout button
    this.setupCheckoutButton();

    // Setup sticky footer
    this.setupStickyFooter();

    // Initialize UI
    this.updateUI();
    this.updateStickyFooter();
  }

  setupTabs() {
    const tabs = this.querySelectorAll('[data-tab]');
    const panels = this.querySelectorAll('[data-tab-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabNumber = parseInt(tab.dataset.tab);

        // Update active states
        tabs.forEach((t) => t.classList.remove('bundle-builder__main-tab--active'));
        panels.forEach((p) => p.classList.remove('bundle-builder__main-panel--active'));

        tab.classList.add('bundle-builder__main-tab--active');
        const activePanel = this.querySelector(`[data-tab-panel="${tabNumber}"]`);
        if (activePanel) {
          activePanel.classList.add('bundle-builder__main-panel--active');
        }

        this.state.currentTab = tabNumber;
      });
    });
  }

  setupProductButtons() {
    const addButtons = this.querySelectorAll('[data-add-to-bundle]');
    const quantityButtons = this.querySelectorAll('[data-action]');

    addButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleAddToBundle(e));
    });

    quantityButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const action = button.dataset.action;
        if (action === 'increase') {
          this.increaseQuantity(e);
        } else if (action === 'decrease') {
          this.decreaseQuantity(e);
        }
      });
    });
  }

  setupCheckoutButton() {
    const checkoutBtn = this.querySelector('[data-checkout-btn]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => this.goToCheckout());
    }
  }

  setupStickyFooter() {
    const footer = this.querySelector('[data-sticky-footer]');
    const footerBar = this.querySelector('[data-footer-bar]');
    const footerClose = this.querySelector('[data-footer-close]');
    const footerCheckout = this.querySelector('[data-footer-checkout]');
    const footerCheckoutOutside = this.querySelector('[data-footer-checkout-btn-outside]');

    if (footerBar) {
      footerBar.addEventListener('click', () => {
        footer.classList.add('bundle-builder__sticky-footer--expanded');
      });
    }

    if (footerClose) {
      footerClose.addEventListener('click', () => {
        footer.classList.remove('bundle-builder__sticky-footer--expanded');
      });
    }

    if (footerCheckout) {
      footerCheckout.addEventListener('click', () => this.goToCheckout());
    }

    if (footerCheckoutOutside) {
      footerCheckoutOutside.addEventListener('click', () => this.goToCheckout());
    }
  }

  async handleAddToBundle(event) {
    const button = event.target.closest('[data-add-to-bundle]');
    if (!button || button.disabled) return;

    const productCard = button.closest('.bundle-builder__product-card');
    const productId = productCard.dataset.productId;
    const variantId = productCard.dataset.variantId;
    const title = productCard.dataset.productTitle;
    const price = parseInt(productCard.dataset.productPrice);
    const originalPrice = parseInt(productCard.dataset.productOriginalPrice);
    const image = productCard.dataset.productImage;
    const type = productCard.dataset.productType;

    const btnText = button.querySelector('.bundle-builder__add-btn-text');
    const qtyInput = productCard.querySelector('.bundle-builder__qty-input');

    // Get quantity from input (default to 1 if not found)
    console.log('Quantity input element:', qtyInput);
    console.log('Quantity input value:', qtyInput ? qtyInput.value : 'Input not found');
    const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    console.log('Parsed quantity:', quantity);

    // Show "Adding to bundle..." state
    button.disabled = true;
    button.classList.add('bundle-builder__add-btn--loading');
    if (btnText) btnText.textContent = 'Adding to bundle...';

    try {
      console.log(`Adding ${quantity}x ${title} to cart, Variant ID:`, variantId);

      // Add the specified quantity to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: {
            _bundle_id: this.state.bundleId,
            _bundle_type: 'free-bundle-pack',
            _bundle_price_type: type,
            _source: 'free_bundle_builder',
          }
        }),
      });

      const data = await response.json();
      console.log('Add to cart response:', data);

      if (!response.ok) {
        const errorMsg = data.description || data.message || `Failed to add ${title}`;
        throw new Error(errorMsg);
      }

      // Check if product already in state
      let bottle = this.state.selectedBottles.find(b => b.productId === productId);

      if (bottle) {
        // Update existing quantity
        bottle.quantity += quantity;
      } else {
        // Add new product to state
        this.state.selectedBottles.push({
          productId,
          variantId,
          title,
          price,
          originalPrice,
          image,
          type,
          quantity: quantity,
        });
      }

      // Show "Added" state briefly, then reset
      button.classList.remove('bundle-builder__add-btn--loading');
      button.classList.add('bundle-builder__add-btn--added');
      if (btnText) btnText.textContent = 'Added';

      // After 800ms, reset button to normal state
      setTimeout(() => {
        button.classList.remove('bundle-builder__add-btn--added');
        button.disabled = false;
        if (btnText) btnText.textContent = 'Add to Bundle';
      }, 800);

      this.showInlineMessage(productId, `${quantity}x added to bundle`, 'success');
      this.updateUI();
      this.updateStickyFooter();

    } catch (error) {
      console.error('Error adding to cart:', error);
      button.classList.remove('bundle-builder__add-btn--loading');
      button.disabled = false;
      if (btnText) btnText.textContent = 'Add to Bundle';
      this.showInlineMessage(productId, 'Failed to add', 'removed');
    }
  }

  increaseQuantity(event) {
    const button = event.target.closest('[data-action="increase"]');
    if (!button || button.disabled) return;

    const productCard = button.closest('.bundle-builder__product-card');
    const qtyInput = productCard.querySelector('.bundle-builder__qty-input');

    if (qtyInput) {
      const currentQty = parseInt(qtyInput.value) || 1;
      const newQty = currentQty + 1;
      qtyInput.value = newQty;
      console.log(`Increased quantity to: ${newQty} for input:`, qtyInput);
    }
  }

  decreaseQuantity(event) {
    const button = event.target.closest('[data-action="decrease"]');
    if (!button || button.disabled) return;

    const productCard = button.closest('.bundle-builder__product-card');
    const qtyInput = productCard.querySelector('.bundle-builder__qty-input');

    if (qtyInput) {
      const currentQty = parseInt(qtyInput.value) || 1;
      // Can't go below 1
      if (currentQty > 1) {
        const newQty = currentQty - 1;
        qtyInput.value = newQty;
        console.log(`Decreased quantity to: ${newQty} for input:`, qtyInput);
      }
    }
  }

  async removeFromBundle(productId) {
    const bottle = this.state.selectedBottles.find(b => b.productId === productId);
    if (!bottle || bottle.quantity === 0) return;

    const variantId = bottle.variantId;

    try {
      // Update cart - decrease by 1
      await this.updateCartQuantity(variantId, -1);

      // Update local state
      bottle.quantity -= 1;

      if (bottle.quantity === 0) {
        // Remove from array if quantity is 0
        const index = this.state.selectedBottles.findIndex(b => b.productId === productId);
        this.state.selectedBottles.splice(index, 1);
      }

      this.showInlineMessage(productId, 'Removed from bundle', 'removed');
      this.updateUI();
      this.updateStickyFooter();

    } catch (error) {
      console.error('Error removing from cart:', error);
      this.showInlineMessage(productId, 'Failed to remove', 'removed');
    }
  }

  async updateCartQuantity(variantId, delta) {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Find all cart items with this variant and bundle ID
      const cartItems = cart.items.filter(item =>
        item.variant_id == variantId &&
        item.properties._bundle_id === this.state.bundleId
      );

      if (cartItems.length > 0) {
        // Get total quantity for this product in cart
        const totalQty = cartItems.reduce((sum, item) => sum + item.quantity, 0);
        const newQty = totalQty + delta;

        // Update the first item to the new quantity
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: cartItems[0].key,
            quantity: Math.max(0, newQty)
          })
        });

        // Remove any duplicate items
        for (let i = 1; i < cartItems.length; i++) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: cartItems[i].key,
              quantity: 0
            })
          });
        }
      }
    } catch (error) {
      console.error('Error updating cart quantity:', error);
      throw error;
    }
  }

  updateButtonStates() {
    // No longer needed - quantity controls don't have limits
    // Keep method for compatibility but make it empty
  }

  updateUI() {
    this.updateCounter();
    this.updateCheckoutButton();
  }

  updateCounter() {
    const countEl = this.querySelector('[data-count]');
    const fillEl = this.querySelector('[data-counter-fill]');
    const savingsSummary = this.querySelector('[data-savings-summary]');
    const totalSavingsEl = this.querySelector('[data-total-savings]');

    // Calculate total bottles (sum of all quantities)
    const bottleCount = this.state.selectedBottles.reduce((sum, bottle) => sum + bottle.quantity, 0);

    if (countEl) {
      countEl.textContent = `${bottleCount} bottles selected`;
    }

    if (fillEl) {
      const percentage = Math.min((bottleCount / this.state.maxBottles) * 100, 100);
      fillEl.style.width = `${percentage}%`;
    }

    // Calculate and display bundle discount
    if (savingsSummary && totalSavingsEl) {
      if (bottleCount >= 4) {
        // Show the bundle discount amount based on bottle selection
        const bundleDiscountAmount = this.getBundleDiscountAmount();
        totalSavingsEl.textContent = `$${bundleDiscountAmount.toFixed(2)}`;
        savingsSummary.style.display = 'flex';
      } else {
        savingsSummary.style.display = 'none';
      }
    }
  }

  getBundleDiscountAmount() {
    // Count standard and max bottles (sum quantities)
    const standardCount = this.state.selectedBottles
      .filter(b => b.type === 'standard')
      .reduce((sum, b) => sum + b.quantity, 0);
    const maxCount = this.state.selectedBottles
      .filter(b => b.type === 'max')
      .reduce((sum, b) => sum + b.quantity, 0);

    // For discount calculation, only consider the first 4 bottles
    const totalCount = standardCount + maxCount;
    if (totalCount < 4) return 0;

    // Determine the mix of the first 4 bottles
    const first4Standard = Math.min(standardCount, 4);
    const first4Max = Math.min(4 - first4Standard, maxCount);

    // Return the total discount amount (Bundle Discount + $20 Promo + Free Shipping)
    if (first4Standard === 4 && first4Max === 0) {
      return 45.00; // $30 bundle + $15 promo
    } else if (first4Standard === 3 && first4Max === 1) {
      return 47.50; // $32.50 bundle + $15 promo
    } else if (first4Standard === 2 && first4Max === 2) {
      return 50.00; // $35 bundle + $15 promo
    } else if (first4Standard === 1 && first4Max === 3) {
      return 52.50; // $37.50 bundle + $15 promo
    } else if (first4Standard === 0 && first4Max === 4) {
      return 55.00; // $40 bundle + $15 promo
    }

    return 0; // No valid bundle combination
  }

  updateCheckoutButton() {
    const checkoutBtn = this.querySelector('[data-checkout-btn]');
    if (!checkoutBtn) return;

    // Calculate total bottles (sum of all quantities)
    const bottleCount = this.state.selectedBottles.reduce((sum, bottle) => sum + bottle.quantity, 0);

    // Enable checkout if minimum 4 bottles (no gift card required)
    if (bottleCount >= this.state.maxBottles) {
      checkoutBtn.disabled = false;
      checkoutBtn.classList.add('bundle-builder__checkout-btn--ready');
    } else {
      checkoutBtn.disabled = true;
      checkoutBtn.classList.remove('bundle-builder__checkout-btn--ready');
    }
  }

  updateStickyFooter() {
    const footer = this.querySelector('[data-sticky-footer]');
    const footerItems = this.querySelector('[data-footer-items]');
    const footerCount = this.querySelector('[data-footer-count]');
    const footerBarText = this.querySelector('[data-footer-bar-text]');
    const footerProgressText = this.querySelector('[data-footer-progress-text]');
    const footerSavings = this.querySelector('[data-footer-savings]');
    const footerSavingsAmount = this.querySelector('[data-footer-savings-amount]');

    if (!footer || !footerItems) return;

    // Calculate total bottles (sum of all quantities)
    const bottleCount = this.state.selectedBottles.reduce((sum, bottle) => sum + bottle.quantity, 0);

    // Always show footer (even when empty to display initial message)
    footer.classList.add('bundle-builder__sticky-footer--visible');

    // Update count
    if (footerCount) {
      footerCount.textContent = `(${bottleCount})`;
    }

    // Update footer bar text with progress indicator
    const remaining = Math.max(0, this.state.maxBottles - bottleCount);

    let progressText = '';
    if (bottleCount === 0) {
      progressText = 'Start Creating a Bundle (Min 4 products)';
    } else if (bottleCount < this.state.maxBottles) {
      progressText = `${bottleCount} bottles selected (${remaining} more needed)`;
    } else {
      progressText = `${bottleCount} bottles selected - Proceed to checkout`;
    }

    // Update mobile footer bar text
    if (footerBarText) {
      footerBarText.textContent = progressText;
    }

    // Update desktop footer progress text
    if (footerProgressText) {
      footerProgressText.textContent = progressText;
    }

    // Calculate and display bundle discount in footer
    if (footerSavings && footerSavingsAmount) {
      if (bottleCount >= 4) {
        // Show the bundle discount amount based on bottle selection
        const bundleDiscountAmount = this.getBundleDiscountAmount();
        footerSavingsAmount.textContent = `$${bundleDiscountAmount.toFixed(2)}`;
        footerSavings.style.display = 'block';
      } else {
        footerSavings.style.display = 'none';
      }
    }

    // Update footer items
    footerItems.innerHTML = '';

    // Add bottle items with quantity badges
    this.state.selectedBottles.forEach(bottle => {
      const item = document.createElement('div');
      item.className = 'bundle-builder__footer-item';
      item.innerHTML = `
        <img src="${bottle.image}" alt="${bottle.title}">
        ${bottle.quantity > 1 ? `<span class="bundle-builder__footer-item-qty">${bottle.quantity}x</span>` : ''}
        <button class="bundle-builder__footer-item-remove" data-remove-product="${bottle.productId}">×</button>
      `;

      const removeBtn = item.querySelector('[data-remove-product]');
      removeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        // Remove one from bundle
        this.removeFromBundle(bottle.productId);
      });

      footerItems.appendChild(item);
    });

    // Show outside checkout button (always visible)
    const outsideCheckout = this.querySelector('[data-footer-checkout-outside]');
    if (outsideCheckout) {
      outsideCheckout.setAttribute('style', 'display: block;');
    }
  }

  calculateBundleDiscount() {
    // Count standard and max bottles (sum quantities)
    const standardCount = this.state.selectedBottles
      .filter(b => b.type === 'standard')
      .reduce((sum, b) => sum + b.quantity, 0);
    const maxCount = this.state.selectedBottles
      .filter(b => b.type === 'max')
      .reduce((sum, b) => sum + b.quantity, 0);

    // For discount calculation, only consider the first 4 bottles
    const totalCount = standardCount + maxCount;
    if (totalCount < 4) return null;

    // Determine the mix of the first 4 bottles
    const first4Standard = Math.min(standardCount, 4);
    const first4Max = Math.min(4 - first4Standard, maxCount);

    // Determine which discount code to use based on bottle mix
    if (first4Standard === 4 && first4Max === 0) {
      return this.discountCodes['4std']; // 4 Standard
    } else if (first4Standard === 3 && first4Max === 1) {
      return this.discountCodes['3s1m']; // 3 Standard + 1 Max
    } else if (first4Standard === 2 && first4Max === 2) {
      return this.discountCodes['2s2m']; // 2 Standard + 2 Max
    } else if (first4Standard === 1 && first4Max === 3) {
      return this.discountCodes['1s3m']; // 1 Standard + 3 Max
    } else if (first4Standard === 0 && first4Max === 4) {
      return this.discountCodes['4max']; // 4 Max
    }

    return null; // No valid bundle combination
  }

  async goToCheckout() {
    // Calculate total bottles (sum of all quantities)
    const bottleCount = this.state.selectedBottles.reduce((sum, bottle) => sum + bottle.quantity, 0);

    if (bottleCount < this.state.maxBottles) {
      alert('Please select at least 4 bottles to checkout');
      return;
    }

    try {
      console.log('[Free Bundle] Starting checkout process...');

      // Show loading state
      const checkoutBtns = this.querySelectorAll('[data-footer-checkout], [data-footer-checkout-btn-outside], [data-checkout-btn]');
      checkoutBtns.forEach(btn => {
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = '0.5';
          const originalText = btn.textContent;
          btn.dataset.originalText = originalText;
          btn.textContent = 'Preparing checkout...';
        }
      });

      // Create loading overlay
      const loadingOverlay = document.createElement('div');
      loadingOverlay.className = 'free-bundle-loading-overlay';
      loadingOverlay.innerHTML = `
        <div class="loading-spinner"></div>
        <div class="loading-text">Preparing your bundle for checkout...</div>
      `;
      loadingOverlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        color: white;
        font-size: 18px;
      `;
      document.body.appendChild(loadingOverlay);

      // Add all bottles from state to cart (simple sequential approach)
      console.log('[Free Bundle] Adding all bottles to cart...');
      for (const bottle of this.state.selectedBottles) {
        console.log(`[Free Bundle] Adding to cart: ${bottle.title} (qty: ${bottle.quantity})`);

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: bottle.variantId,
                quantity: bottle.quantity
              }]
            })
          });
        } catch (error) {
          console.error('[Free Bundle] Error adding bottle:', error);
        }
      }

      // Add free products to cart
      if (this.freeProducts && this.freeProducts.length > 0) {
        console.log('[Free Bundle] Adding free products to cart...');

        for (const freeProduct of this.freeProducts) {
          console.log(`[Free Bundle] Adding free product: ${freeProduct.title} (qty: ${freeProduct.quantity})`);

          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: freeProduct.variantId,
                  quantity: freeProduct.quantity,
                  properties: {
                    _bundle_id: this.state.bundleId,
                    _source: 'free_bundle_builder',
                    _type: 'free_product'
                  }
                }]
              })
            });
          } catch (error) {
            console.error('[Free Bundle] Error adding free product:', error);
          }
        }
      }

      // Get discount code
      const discountCode = this.calculateBundleDiscount();

      // Build checkout URL
      let checkoutUrl = '/checkout';
      if (discountCode && discountCode.trim() !== '') {
        checkoutUrl = `/checkout?discount=${encodeURIComponent(discountCode.trim())}`;
      }

      console.log('[Free Bundle] Redirecting to checkout:', checkoutUrl);

      // Redirect to checkout (loading will remain visible during redirect)
      // Checkout must go through the sticky.io redirect, never native Shopify checkout
      if (window.mcStickyRedirect) { window.mcStickyRedirect(); return; }
      window.location.href = checkoutUrl;

    } catch (error) {
      console.error('[Free Bundle] Checkout error:', error);

      // Remove loading overlay
      const overlay = document.querySelector('.free-bundle-loading-overlay');
      if (overlay) {
        overlay.remove();
      }

      // Re-enable buttons and restore text
      const checkoutBtns = this.querySelectorAll('[data-footer-checkout], [data-footer-checkout-btn-outside], [data-checkout-btn]');
      checkoutBtns.forEach(btn => {
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '1';
          if (btn.dataset.originalText) {
            btn.textContent = btn.dataset.originalText;
            delete btn.dataset.originalText;
          }
        }
      });

      alert('There was an error preparing your checkout. Please try again.');
    }
  }

  showInlineMessage(productId, message, type = 'success') {
    const messageEl = this.querySelector(`[data-add-message="${productId}"]`);
    if (!messageEl) return;

    messageEl.textContent = message;
    messageEl.classList.add('bundle-builder__add-message--show');

    if (type === 'success') {
      messageEl.classList.add('bundle-builder__add-message--success');
      messageEl.classList.remove('bundle-builder__add-message--removed');
    } else if (type === 'removed') {
      messageEl.classList.add('bundle-builder__add-message--removed');
      messageEl.classList.remove('bundle-builder__add-message--success');
    }

    setTimeout(() => {
      messageEl.classList.remove('bundle-builder__add-message--show');

      setTimeout(() => {
        messageEl.classList.remove('bundle-builder__add-message--success', 'bundle-builder__add-message--removed');
        messageEl.textContent = '';
      }, 300);
    }, 2500);
  }

  generateBundleId() {
    return `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  checkForCheckoutRecovery() {
    // Check if we have a stored checkout state from a previous attempt
    const storedState = sessionStorage.getItem('freeBundleCheckoutState');

    if (storedState) {
      try {
        const state = JSON.parse(storedState);

        // Check if the state is less than 5 minutes old
        const stateAge = Date.now() - state.timestamp;
        const fiveMinutes = 5 * 60 * 1000;

        if (stateAge < fiveMinutes) {
          console.log('[Free Bundle] Found recent checkout state, offering recovery...');

          // Check if checkout was successful
          const checkoutSuccess = sessionStorage.getItem('freeBundleCheckoutSuccess');
          if (checkoutSuccess === 'true') {
            // Clear the state if checkout was successful
            sessionStorage.removeItem('freeBundleCheckoutState');
            sessionStorage.removeItem('freeBundleCheckoutSuccess');
            console.log('[Free Bundle] Previous checkout was successful, clearing state');
            return;
          }

          // Offer to restore the bundle
          const shouldRestore = confirm('It looks like you were in the process of checking out. Would you like to restore your bundle selection?');

          if (shouldRestore) {
            // Restore the bundle state
            this.state.bundleId = state.bundleId;
            this.state.selectedBottles = state.items || [];

            // Update the UI
            this.updateCounter();
            this.updateStickyFooter();
            this.updateCheckoutButton();

            console.log('[Free Bundle] Bundle state restored successfully');

            // Show a message
            const message = document.createElement('div');
            message.style.cssText = `
              position: fixed;
              top: 20px;
              right: 20px;
              background: #10B981;
              color: white;
              padding: 12px 20px;
              border-radius: 8px;
              font-size: 14px;
              z-index: 10000;
              animation: slideIn 0.3s ease;
            `;
            message.textContent = 'Your bundle selection has been restored!';
            document.body.appendChild(message);

            setTimeout(() => {
              message.remove();
            }, 3000);
          } else {
            // Clear the stored state if user doesn't want to restore
            sessionStorage.removeItem('freeBundleCheckoutState');
            sessionStorage.removeItem('freeBundleCheckoutSuccess');
          }
        } else {
          // State is too old, clear it
          sessionStorage.removeItem('freeBundleCheckoutState');
          sessionStorage.removeItem('freeBundleCheckoutSuccess');
          console.log('[Free Bundle] Checkout state is too old, clearing');
        }
      } catch (error) {
        console.error('[Free Bundle] Error recovering checkout state:', error);
        sessionStorage.removeItem('freeBundleCheckoutState');
        sessionStorage.removeItem('freeBundleCheckoutSuccess');
      }
    }
  }
}

// Register the custom element
customElements.define('free-bundle-component', FreeBundleComponent);
